import React, { useEffect, useState } from 'react';
import logo from '../../assets/images/logo.svg';
import { nav, voterSignIn } from '../Data/Data';
import './Header.css';

const Header = () => {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 8);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    useEffect(() => {
        const onKey = (e) => e.key === 'Escape' && setOpen(false);
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, []);

    const close = () => setOpen(false);

    return (
        <header className={`header${scrolled ? ' is-scrolled' : ''}${open ? ' is-open' : ''}`}>
            <div className="container header-inner">
                <a href="#home" className="header-logo" onClick={close}>
                    <img src={logo} alt="Instant Elect, electronic voting systems" width="222" height="41" />
                </a>
                <button
                    type="button"
                    className="header-toggle"
                    aria-expanded={open}
                    aria-controls="site-nav"
                    onClick={() => setOpen(!open)}
                >
                    <span className="visually-hidden">{open ? 'Close menu' : 'Open menu'}</span>
                    <span aria-hidden="true" />
                </button>
                <nav id="site-nav" className="header-nav" aria-label="Main">
                    {nav.map((item) => (
                        <a key={item.href} href={item.href} onClick={close}>{item.label}</a>
                    ))}
                    <a href={voterSignIn} className="btn btn-ghost header-signin">Voter sign-in</a>
                </nav>
            </div>
        </header>
    );
};

export default Header;
